import { useTranslate } from '../../lib'

export default function WizardStep3({ formData, setFormData }) {
  const { t } = useTranslate();

  return (
    <div className="wizard-step">
      <h2 className="mb-4" style={{ color: '#0B5FA3', fontSize: 20 }}>
        {t('menu.genai.aiPersonaDetails')}
      </h2>

      <div className='d-flex flex-column w-100' style={{ flexGrow: '1', marginTop: 30 }}>
        <div className='flex flex-column mt-1'>
          <label style={{ fontSize: 14, color: "#2E2E2E", fontWeight: '700', marginBottom: 8 }}>Mood</label>
          <div className='flex flex-column'>
            {[
              { value: 'friendly', label: t('menu.genai.moodOptions.friendly'), desc: t('menu.genai.moodDescriptions.friendly') },
              { value: 'angry', label: t('menu.genai.moodOptions.angry'), desc: t('menu.genai.moodDescriptions.angry') },
              { value: 'sad', label: t('menu.genai.moodOptions.sad'), desc: t('menu.genai.moodDescriptions.sad') },
              { value: 'unfriendly', label: t('menu.genai.moodOptions.unfriendly'), desc: t('menu.genai.moodDescriptions.unfriendly') },
              { value: 'excited', label: t('menu.genai.moodOptions.excited'), desc: t('menu.genai.moodDescriptions.excited') },
              { value: 'calm', label: t('menu.genai.moodOptions.calm'), desc: t('menu.genai.moodDescriptions.calm') },
            ].map(opt => (
              <div key={opt.value} className='mb-2'>
                <label className='flex flex-row items-center' style={{ cursor: 'pointer', fontWeight: formData.personaMood === opt.value ? '700' : '400' }}>
                  <input
                    type='radio'
                    name='persona_mood'
                    value={opt.value}
                    checked={formData.personaMood === opt.value}
                    onChange={() => setFormData({ ...formData, personaMood: opt.value })}
                    style={{ marginRight: 8 }}
                  />
                  <span style={{ fontSize: 15 }}>{opt.label}</span>
                </label>
                <span style={{ fontSize: 13, color: '#6B6B6B', marginLeft: 22, display: 'block' }}>{opt.desc}</span>
              </div>
            ))}
          </div>
        </div>

        <div className='flex flex-column mt-2'>
          <label style={{ fontSize: 14, color: "#2E2E2E", fontWeight: '700', marginBottom: 8 }}>{t('menu.genai.responseLength')}</label>
          <div className='flex flex-column'>
            {[
              { value: 'short', label: t('menu.genai.responseLengthOptions.short'), desc: '' },
              { value: 'medium', label: t('menu.genai.responseLengthOptions.medium'), desc: '' },
              { value: 'long', label: t('menu.genai.responseLengthOptions.long'), desc: '' }
            ].map(opt => (
              <div key={opt.value} className='mb-2'>
                <label className='flex flex-row items-center' style={{ cursor: 'pointer', fontWeight: formData.personaResponseLength === opt.value ? '700' : '400' }}>
                  <input
                    type='radio'
                    name='persona_response_length'
                    value={opt.value}
                    checked={formData.personaResponseLength === opt.value}
                    onChange={() => setFormData({ ...formData, personaResponseLength: opt.value })}
                    style={{ marginRight: 8 }}
                  />
                  <span style={{ fontSize: 15 }}>{opt.label}</span>
                </label>
                <span style={{ fontSize: 13, color: '#6B6B6B', marginLeft: 22, display: 'block' }}>{opt.desc}</span>
              </div>
            ))}
          </div>
        </div>

        <div className='flex flex-column mt-2'>
          <label style={{ fontSize: 14, color: "#2E2E2E", fontWeight: '700', marginBottom: 8 }}>
            {t('menu.genai.talkativeMood')}
          </label>
          <div className='flex flex-column'>
            {[
              { value: 'yes', label: t('menu.genai.talkativeOptions.yes'), desc: t('menu.genai.talkativeDescriptions.yes') },
              { value: 'no', label: t('menu.genai.talkativeOptions.no'), desc: t('menu.genai.talkativeDescriptions.no') },
            ].map(opt => (
              <div key={opt.value} className='mb-2'>
                <label className='flex flex-row items-center' style={{ cursor: 'pointer', fontWeight: formData.personaTalkativeMood === opt.value ? '700' : '400' }}>
                  <input
                    type='radio'
                    name='persona_talkative_mood'
                    value={opt.value}
                    checked={formData.personaTalkativeMood === opt.value}
                    onChange={() => setFormData({ ...formData, personaTalkativeMood: opt.value })}
                    style={{ marginRight: 8 }}
                  />
                  <span style={{ fontSize: 15 }}>{opt.label}</span>
                </label>
                <span style={{ fontSize: 13, color: '#6B6B6B', marginLeft: 22, display: 'block' }}>{opt.desc}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
